import { createClient } from 'contentful';

const clients = {};

const environments = {
  preview: {
    space: 'c9fg5kdzsxhp',
    accessToken:
      '218118f3c489a63dfc305480b6529b36efc0c0a12da7bfdea85fd69ed23271a6',
    host: 'preview.contentful.com',
  },
  production: {
    space: 'c9fg5kdzsxhp',
    accessToken:
      '68a7a257e2736dfb2dbed3e2e4596970b50d0e3561aaaf6b646a8e700e19f109',
    host: 'cdn.contentful.com',
  },
};

/**
 * @memberof module:contentful
 * @param {string} environmentName The name of the contentful environment. Valid
 * options are `preview` or `production`. NOTE: This is a contentful environment
 * not a normal updater environment.
 *
 * @returns {Object} A contentful client OR null if something goes wrong during
 * client instantiation.
 *
 * @description Returns a contentful client that points at the given
 * environment. This client is a singleton and will only be created once per
 * call. Subsequent calls return a cached version. See
 * [here](https://contentful.github.io/contentful.js/contentful/latest/ContentfulClientAPI.html)
 * for information about how to use the contentful client.
 */
export function getClient(cmsEnvironmentName) {
  if (clients[cmsEnvironmentName]) {
    return clients[cmsEnvironmentName];
  }

  try {
    return createClient(environments[cmsEnvironmentName]);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    return null;
  }
}
